import { render } from "./skeletonCard.vue?vue&type=template&id=9a1dae20&scoped=true"
import script from "./skeletonCard.vue?vue&type=script&lang=js"
export * from "./skeletonCard.vue?vue&type=script&lang=js"

import "./skeletonCard.vue?vue&type=style&index=0&id=9a1dae20&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9a1dae20"]])

export default __exports__